import * as React from 'react';

import ReactDOMServer from 'react-dom/server';

import {CopyIconButton} from 'shells/button/copy-button/copy-icon-button';
import {Table} from 'shells/table/table';
import type {Row} from 'shells/table/types';

import type {DomainFragment_groupCustom_records as Record} from 'nutshell-graphql-types';

import {getIconInfoForRecord} from './helpers';

import styles from './domain-details.module.css';

type Props = {
    records: Record[];
    includePriority?: boolean;
    firstRow?: React.ReactElement<any>;
    renderRowActionMenu?: (row: Row<Record>) => React.ReactElement<any>;
};

export function RecordTable(props: Props) {
    const {includePriority} = props;

    const columns = React.useMemo(
        () => [
            {
                id: 'record',
                Header: 'Record',
                // @ts-expect-error
                accessor: (row) => row,
                dataType: 'component',
                width: 200,
                Cell: ({cell}: any) => {
                    const {Icon, color} = getIconInfoForRecord(cell.value.status);
                    const errorMessage = cell.value.errorMessage;

                    return (
                        <div className='flex justify-sb full-width'>
                            <div className='flex align-center'>
                                <div
                                    data-html={true}
                                    data-tip={
                                        errorMessage
                                            ? ReactDOMServer.renderToString(
                                                  <div>{errorMessage}</div>
                                              )
                                            : undefined
                                    }
                                >
                                    <Icon
                                        className='mr-8'
                                        color={color}
                                        size={13}
                                        alignCenter={true}
                                    />
                                </div>
                                <div>{cell.value.record}</div>
                            </div>
                            <CopyIconButton size='small' text={cell.value.record} />
                        </div>
                    );
                },
            },
            {
                id: 'type',
                Header: 'Type',
                // @ts-expect-error
                accessor: (row) => row.type,
                dataType: 'string',
                width: includePriority ? 50 : 100,
                Cell: ({cell}: any) => {
                    return <div className='font-size-small'>{cell.value}</div>;
                },
            },
            {
                id: 'value',
                Header: 'Value',
                // @ts-expect-error
                accessor: (row) => row.value,
                dataType: 'copyableString',
            },
        ],
        [includePriority]
    );

    if (props.includePriority) {
        columns.splice(2, 0, {
            id: 'priority',
            Header: 'Priority',
            accessor: (row) => row.priority,
            dataType: 'string',
            width: 50,
            Cell: ({cell}: any) => {
                return <div className='font-size-small'>{cell.value}</div>;
            },
        });
    }

    return (
        <div className={styles['table-container']}>
            <Table
                renderRowActionMenu={props.renderRowActionMenu}
                firstRow={props.firstRow}
                data={props.records}
                // @ts-expect-error
                columns={columns}
                disableFilters={true}
                disableSorting={true}
                hasBorders={true}
                hasHeaderCellBorders={true}
                hasHeaderBorder={true}
                fullWidth={true}
                headerBackgroundColor='offWhite'
                specialStates={[
                    {
                        shouldRender: () => !props.records.length,
                        // TODO update empty state
                        component: <div className='pad-16'>No records found</div>,
                    },
                ]}
            />
        </div>
    );
}
